import React, { useContext, useEffect, useState } from 'react'
import { BottomDiv, ButtonContainer, ButtonDiv, ButtonForCreateAFunction, CloseDiv, CompanyTypes, CompanyTypesDiv, Container, FormData, Header, InputData, InputDiv, InputLabel, SectionDiv, SelectData, TabDiv, TabsDiv, TabText } from './style'
import axios from 'axios'
import close from '../../assets/close-icon.svg'
import plus from '../../assets/productions/plus.svg'
import ModalContext from '../../contexts/ModalContext'
import { sectionsInModal } from './utils'
import DisponibilityComponent from './DisponibilityComponent'
import SelectFunctionsComponent, { functionsType } from './SelectFunctionComponent'
import SelectTypeComponent, { typesInterface } from './SelectTypeComponent'
import InsertCEPComponent from './InsertCEPComponent'
import { FeedbackContext } from '../../contexts/FeedbackContext'

export interface CompanyInterface{
  cnpj: string
  companyName: string
  stateRegistration: string
  contactName: string
  email: string
  phone: string
  activedDays:number[]
  startTime: string
  endTime: string
  functions: functionsType[]
  companyTypes: typesInterface
  cep:string
  state:{id:number, name:string}
  city:{id:number, name:string}
  neighborhood:{id:number, name:string}
  street:string
  complement:string
  number:string
}

const AddCompanyModal:React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const { setFeedback } = useContext(FeedbackContext)
  const [ formData, setFormData ] = useState<CompanyInterface>({
    cnpj:'',
    companyName:'',
    stateRegistration:'',
    contactName:'',
    email:'',
    phone:'',
    activedDays:[],
    startTime:'00:00',
    endTime:'00:00',
    functions:[],
    companyTypes:{typeName:'', id:[]},
    cep:'',
    state:{id:0, name:''},
    city:{id:0, name:''},
    neighborhood:{id:0, name:''},
    street:'',
    complement:'',
    number:''
  })

  const handleEditForm = (e:any, field:keyof CompanyInterface) => {
    if(field === 'state' || field === 'city' || field === 'neighborhood'){
      return setFormData(prev => ({
        ...prev,
        [field]:{...prev[field], name:e.target.value}
      }))
    }
    setFormData(prev => ({
      ...prev,
      [field]:e.target.value
    }))
  }

  const handleViewValue = (field:keyof CompanyInterface) => {
    if(field === 'state' || field === 'city' || field === 'neighborhood')
      return formData[field].name
    return formData[field]
  }

  const maskCNPJ = (value:any) => {
    return value
      .replace(/\D/g, '') 
      .replace(/^(\d{2})(\d)/, '$1.$2') 
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3') 
      .replace(/\.(\d{3})(\d)/, '.$1/$2') 
      .replace(/(\d{4})(\d)/, '$1-$2') 
      .slice(0, 18) 
  }

  const maskPhone = (value:any) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4,5})(\d{4})$/, '$1-$2')
      .slice(0, 15)
  }
  
  
  const handleSubmit = () => {
    axios.post(`${process.env.REACT_APP_COMPANIES_BASE_URL}/companies`, formData)
      .then((response) => {
        if(response.data){
          setModalActive(false)
          setFeedback({
            isOpen:true,
            message:'Empresa cadastrada com sucesso',
            statusOk:true
          })
        }
      })
      .catch((error) => {
        console.error(error)
        setFeedback({
          isOpen:true,
          message:'Erro ao cadastrar empresa',
          statusOk:false
        })
      })
  }
  
  return(
    <Container>
      <Header>
        <h2>Cadastrar Empresa</h2>
        <CloseDiv onClick={() => (setModalActive(false))}>
          <img src={close} />
        </CloseDiv>
      </Header>
      <FormData>
        {sectionsInModal.map((section, index) => 
          <SectionDiv key={index} className={section.className}>
            {section.inputs.map((input, index) => 
              <InputDiv key={index}>
                <InputLabel>{input.label}</InputLabel>
                {input.value === 'activedDays' ?
                  <DisponibilityComponent company={formData} setCompany={setFormData}/>
                : input.value === 'functions' ?
                  <SelectFunctionsComponent company={formData} setCompany={setFormData}/>
                : input.value === 'companyTypes' ?
                  <SelectTypeComponent company={formData} setCompany={setFormData}/>
                : input.value === 'cep' ?
                  <InsertCEPComponent company={formData} setCompany={setFormData}/>
                :
                  <InputData
                    type={input.type}
                    placeholder={input.placeholder}
                    onChange={(e) => {
                      const maskedValue = input.value === 'cnpj' 
                        ? maskCNPJ(e.target.value) 
                        : input.value === 'phone' 
                        ? maskPhone(e.target.value)
                        : e.target.value
                      handleEditForm({ target: { value: maskedValue } }, input.value)
                    }}
                    value={String(handleViewValue(input.value))}
                  />
                }
              </InputDiv>
            )}
          </SectionDiv>
        )}
      </FormData>
      <BottomDiv>
        <ButtonContainer>
        <ButtonDiv onClick={(() => setModalActive(false))} className='cancel'>Cancelar</ButtonDiv>
          <ButtonDiv onClick={handleSubmit}>
            <img src={plus} 
          />
            Cadastrar
          </ButtonDiv>
        </ButtonContainer>
      </BottomDiv> 
    </Container>
  )
}

export default AddCompanyModal